export default __webpack_public_path__ + "static/media/bg_3.63231ea2.jpg";